import { MediaAttachment, MediaFieldUploadStatus } from './types';

/** All attachments belonging to a field, in insertion order. */
export const getFieldAttachments = (
  attachments: Record<string, MediaAttachment>,
  fieldKey: string
): MediaAttachment[] => Object.values(attachments).filter((attachment) => attachment.fieldKey === fieldKey);

/** Committed server media ids for a field (successful uploads only). */
export const getFieldMediaIds = (attachments: Record<string, MediaAttachment>, fieldKey: string): string[] =>
  getFieldAttachments(attachments, fieldKey)
    .filter((attachment) => attachment.status === 'success' && attachment.mediaId)
    .map((attachment) => attachment.mediaId as string);

/** Aggregate upload status for a field, used for UI flags and section gating. */
export const getFieldUploadStatus = (
  attachments: Record<string, MediaAttachment>,
  fieldKey: string
): MediaFieldUploadStatus => {
  const fieldAttachments = getFieldAttachments(attachments, fieldKey);
  return {
    count: fieldAttachments.length,
    successCount: fieldAttachments.filter((attachment) => attachment.status === 'success').length,
    isUploading: fieldAttachments.some((attachment) => attachment.status === 'uploading'),
    hasError: fieldAttachments.some((attachment) => attachment.status === 'error'),
  };
};
